import HandleErrorApi from "./HandleErrorApi";

/**
 * API по доменам
 */
class DomainApi {
    api = new HandleErrorApi();

    /**
     * Перезагрузка иконки домена
     */
    reloadImage(data = {domainName: null})
    {
        return this.api.post('/domain/reload-image', data);
    }

    /**
     * Загрузка конкурентов домена по контекстной рекламе для дашборда
     */
    getDashboardAdConcs(data = {domain: null, base: null})
    {
        return this.api.get('/report/simple/domain_dashboard/adconcurents', data);
    }

    /**
     * Загрузка конкурентов домена по органической выдаче для дашборда
     */
    getDashboardConcs(data = {domain: null, base: null})
    {
        return this.api.get('/report/simple/domain_dashboard/concurents', data);
    }

    /**
     * Загрузка ИИ-ответов домена для дашборда
     */
    getDashboardAiAnswers(data = {domain: null, base: null, limit: null})
    {
        return this.api.get('/report/simple/domain_dashboard/ai-answers', data);
    }

    /**
     * Загрузка конкурентов по ИИ-ответам домена для дашборда
     */
    getDashboardAiConcs(data = {domain: null, base: null, limit: null})
    {
        return this.api.get('/report/simple/domain_dashboard/ai-concurents', data);
    }

    /**
     * Подгрузка подсказок для Autocomplete строки поиска
     * @return {Promise<String[] | []>}
     */
    getSuggestion(type = null, data = {query: null, base: null})
    {
        return this.api.get('/suggestion/' + type, data);
    }
}

export default new DomainApi();
